import { formatTokenOptimizationValue } from "@/domains/library"
import { ZapIcon } from "@/domains/icons/huge-icons/monotone/zap"

import type { EmptyStateViewProps } from "./types"

export const EmptyStateView = ({
  selectedEngineType,
  selectedOptimizationStrategy,
  selectedTokenForDisplay,
  tokenStrategyEstimatedAmount,
  strategies,
  onCastVote,
}: EmptyStateViewProps) => {
  const selectedStrategy = strategies.find((s) => s.id === selectedOptimizationStrategy)
  const isTokenSelected = selectedEngineType === "token" && selectedTokenForDisplay != null

  const targetLabel =
    selectedEngineType === "optimization" && selectedStrategy
      ? "Value"
      : selectedEngineType === "token" && selectedTokenForDisplay
        ? selectedTokenForDisplay.symbol
        : null

  const voteButtonLabel =
    selectedEngineType === "optimization" && selectedStrategy
      ? `VOTE FOR ${selectedStrategy.label.toUpperCase()}`
      : selectedEngineType === "token" && selectedTokenForDisplay
        ? `VOTE FOR ${selectedTokenForDisplay.symbol.toUpperCase()}`
        : "VOTE FOR OPTIMIZED"

  const hasSelection = selectedEngineType != null

  return (
    <div className="group relative">
      <div className="flex flex-col items-center justify-center rounded-3xl border-2 border-dashed border-p400-light bg-p300 py-20 transition-colors group-hover:border-primary-400/30">
        <div className="relative mb-6 h-8 w-16 rounded-xl border-2 border-p400-light transition-colors group-hover:border-primary-400/30">
          <div className="absolute right-[-6px] top-2 h-4 w-1.5 rounded-r-md bg-p400-light transition-colors group-hover:bg-primary-400/30" />
          <div className="flex h-full w-full items-center justify-center">
            <ZapIcon size={14} className="text-p400-light transition-colors group-hover:text-primary-400/30" />
          </div>
        </div>

        <h3 className="font-bold tracking-tight text-t200">Strategy Loaded</h3>
        <p className="mt-2 max-w-xs px-6 text-center text-sm text-t300">
          {hasSelection && targetLabel != null ? (
            <>
              Ready to execute. You are targeting the highest{" "}
              <span className="font-medium text-t100">{targetLabel}</span> outcomes.
            </>
          ) : (
            "Select a strategy above or add pools manually."
          )}
        </p>

        {isTokenSelected && selectedTokenForDisplay && (
          <div className="mt-4 rounded-lg border border-p400-light bg-p400/50 px-4 py-3 text-center">
            <p className="text-lg font-bold text-t100">
              {formatTokenOptimizationValue(
                tokenStrategyEstimatedAmount.toString(),
                selectedTokenForDisplay.decimals,
              )}{" "}
              {selectedTokenForDisplay.symbol}
            </p>
            <p className="mt-1 text-xs text-t300">
              {selectedTokenForDisplay.symbol === "WETH"
                ? "Prioritize WETH bribes and gas rebates."
                : `Optimized for maximum ${selectedTokenForDisplay.symbol} accumulation.`}
            </p>
          </div>
        )}

        <button
          type="button"
          onClick={onCastVote}
          className="mt-8 rounded-2xl bg-primary-400 px-10 py-4 text-sm font-black tracking-widest text-white shadow-[0_0_20px_rgba(37,99,235,0.3)] transition-all hover:scale-105 hover:bg-primary-500 active:scale-95"
        >
          {voteButtonLabel}
        </button>
      </div>
    </div>
  )
}
